import React, { useEffect, useState } from 'react';
import { Lock, Clock, HelpCircle, CheckCircle } from 'lucide-react';
export function VslPage() {
  const [showButton, setShowButton] = useState(false);
  useEffect(() => {
    // Timer for 15 minutes and 30 seconds (930 seconds)
    const timer = setTimeout(() => {
      setShowButton(true);
    }, 930 * 1000);
    return () => clearTimeout(timer);
  }, []);
  return <div className="min-h-screen bg-black text-white font-sans selection:bg-[#FDB931] selection:text-black" data-id="element-349">
      {/* Main Content Container */}
      <main className="max-w-4xl mx-auto px-4 py-8 md:py-16 flex flex-col items-center text-center" data-id="element-350">
        {/* ABOVE THE FOLD */}
        <div className="mb-8 md:mb-12 space-y-6 animate-fade-in-up" data-id="element-351">
          <h1 className="text-2xl md:text-4xl lg:text-5xl xl:text-6xl font-black uppercase leading-tight tracking-tight" data-id="element-352">
            Mira esto antes de intentar{' '}
            <span className="text-[#FDB931]" data-id="element-353">lanzar otra cosa</span>
          </h1>

          <h2 className="text-base md:text-xl lg:text-2xl text-gray-300 font-medium max-w-2xl mx-auto leading-relaxed" data-id="element-354">
            Si sigues empezando por el producto, nada va a ser consistente.
          </h2>

          <div className="flex items-center justify-center gap-2 text-xs md:text-sm text-gray-500 bg-white/5 py-2 px-4 rounded-full w-fit mx-auto border border-white/10" data-id="element-355">
            <Clock className="w-4 h-4" data-id="element-356" />
            <p data-id="element-357">
              Este video dura ~20 minutos. Míralo completo para entender por qué
              el problema nunca fue el esfuerzo.
            </p>
          </div>
        </div>

        {/* VIDEO PLAYER SECTION */}
        <div className="w-full mb-12 relative group" data-id="element-358">
          <div className="absolute -inset-1 bg-gradient-to-b from-[#FDB931]/20 to-transparent rounded-2xl blur-lg opacity-50 group-hover:opacity-75 transition-opacity duration-500" data-id="element-359"></div>
          <div className="relative aspect-video bg-gray-900 rounded-xl border border-gray-800 overflow-hidden shadow-2xl" data-id="element-360">
            {/* Placeholder for Video Player */}
            <div className="absolute inset-0 flex items-center justify-center bg-black/50" data-id="element-361">
              <div className="text-center p-8" data-id="element-362">
                <div className="w-20 h-20 bg-[#FDB931] rounded-full flex items-center justify-center mx-auto mb-4 cursor-pointer hover:scale-110 transition-transform" data-id="element-363">
                  <div className="w-0 h-0 border-t-[12px] border-t-transparent border-l-[20px] border-l-black border-b-[12px] border-b-transparent ml-1" data-id="element-364"></div>
                </div>
                <p className="text-gray-400 font-mono text-sm" data-id="element-365">
                  Video Player Placeholder
                </p>
                <p className="text-gray-600 text-xs mt-2" data-id="element-366">(Autoplay ON)</p>
              </div>
            </div>
            {/* In production, replace the above div with your iframe/wistia embed */}
            {/* <iframe src="..." className="w-full h-full" allow="autoplay; fullscreen" /> */}
          </div>
        </div>

        {/* COPY BELOW VIDEO */}
        <div className="max-w-2xl mx-auto space-y-8 mb-12" data-id="element-367">
          <div className="space-y-4 text-gray-300 text-base md:text-lg leading-relaxed" data-id="element-368">
            <p className="font-bold text-white" data-id="element-369">
              No intentes ejecutar nada todavía.
            </p>
            <p data-id="element-370">
              Este video no está diseñado para darte instrucciones, sino para
              mostrarte el error que hace que casi todo falle.
            </p>
            <p className="italic text-gray-400 border-l-2 border-[#FDB931] pl-4 ml-2" data-id="element-371">
              Si algo de esto te resulta incómodo, es normal. La claridad suele
              serlo.
            </p>
          </div>
        </div>

        {/* TIMED BUTTON SECTION */}
        {showButton ? <div className="w-full max-w-2xl animate-fade-in-up" data-id="element-372">
            <div className="bg-white/5 border border-white/10 rounded-2xl p-8 md:p-10 backdrop-blur-sm relative overflow-hidden" data-id="element-373">
              {/* Glow effect */}
              <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-1/2 bg-[#FDB931]/10 blur-3xl rounded-full pointer-events-none" data-id="element-374"></div>

              <div className="relative z-10" data-id="element-375">
                <button className="group w-full bg-gradient-to-b from-[#FDB931] to-[#D68E15] hover:from-[#FFC54D] hover:to-[#E6A02E] text-black font-black text-lg md:text-xl lg:text-2xl uppercase tracking-wide rounded-xl py-5 px-6 shadow-[0_0_30px_rgba(253,185,49,0.3)] transition-all duration-300 transform hover:scale-[1.02] mb-4" data-id="element-376">
                  Acceder al sistema y seguir la secuencia correcta
                </button>

                <div className="flex items-center justify-center gap-2 text-xs md:text-sm text-gray-400 mb-6" data-id="element-377">
                  <Lock className="w-4 h-4" data-id="element-378" />
                  <span data-id="element-379">Acceso inmediato</span>
                  <span className="w-1 h-1 bg-gray-600 rounded-full" data-id="element-380"></span>
                  <span data-id="element-381">Pago único de $297</span>
                </div>

                <div className="text-center" data-id="element-382">
                  <p className="text-sm md:text-base text-gray-300 font-medium" data-id="element-383">
                    No estás comprando información.
                  </p>
                  <p className="text-xs md:text-sm text-gray-500 mt-1" data-id="element-384">
                    Estás evitando cometer el mismo error otra vez.
                  </p>
                </div>
              </div>
            </div>
          </div> : (
      /* Placeholder to prevent layout shift or just empty space?
      Strategy: Keep it empty as per "The button only appears when..." rule.
      Maybe a subtle spacer if needed, but usually it just appears. */
      <div className="h-4" data-id="element-385"></div>)}

        {/* OPTIONAL ELEMENTS (Always visible or timed? Usually always visible or timed with button.
           "Scarcity" and "FAQ" usually go below the button area.
           I'll make them visible only when button is visible to maintain the "focus on video" rule,
           or keep them subtle at the bottom.)
           
           Re-reading: "ELEMENTOS OPCIONALES (RECOMENDADOS)" usually accompany the offer.
           If the offer isn't there, these shouldn't be either. I'll hide them with the button.
         */}

        {showButton && <div className="mt-16 w-full max-w-2xl animate-fade-in-up delay-200" data-id="element-386">
            {/* Scarcity */}
            <div className="flex flex-col items-center gap-2 mb-12 text-xs md:text-sm text-[#FDB931]/80 font-medium uppercase tracking-widest" data-id="element-387">
              <p data-id="element-388">Acceso disponible por tiempo limitado</p>
              <p className="text-xs text-gray-600 normal-case tracking-normal" data-id="element-389">
                Esta página no se comparte públicamente
              </p>
            </div>

            {/* FAQ */}
            <div className="border-t border-gray-800 pt-12 text-left space-y-8" data-id="element-390">
              <div className="space-y-2" data-id="element-391">
                <h3 className="text-sm md:text-base text-white font-bold flex items-center gap-2" data-id="element-392">
                  <HelpCircle className="w-5 h-5 text-gray-500" data-id="element-393" />
                  ¿Es para principiantes?
                </h3>
                <p className="text-gray-400 pl-7 text-xs md:text-sm leading-relaxed" data-id="element-394">
                  Es para personas cansadas de improvisar.
                </p>
              </div>

              <div className="space-y-2" data-id="element-395">
                <h3 className="text-sm md:text-base text-white font-bold flex items-center gap-2" data-id="element-396">
                  <HelpCircle className="w-5 h-5 text-gray-500" data-id="element-397" />
                  ¿Necesito experiencia previa?
                </h3>
                <p className="text-gray-400 pl-7 text-xs md:text-sm leading-relaxed" data-id="element-398">
                  No. Necesitas entender el orden correcto.
                </p>
              </div>

              <div className="space-y-2" data-id="element-399">
                <h3 className="text-sm md:text-base text-white font-bold flex items-center gap-2" data-id="element-400">
                  <CheckCircle className="w-5 h-5 text-gray-500" data-id="element-401" />
                  ¿Cuándo empiezo?
                </h3>
                <p className="text-gray-400 pl-7 text-xs md:text-sm leading-relaxed" data-id="element-402">
                  Acceso inmediato.
                </p>
              </div>
            </div>
          </div>}
      </main>
    </div>;
}